import generalNav from "./general";
import ctcNav from "./ctc";
import programmatiqueNav from "./programmatique";
import arbitrageNav from "./acquisition";
import crmNav from "./crm";
import audienceNav from "./audience";
import socialNav from "./social";
import regieNav from "./regie";
import marmitonNav from "./marmiton";
import partners from "./partners";
import adminNav from "./admin";
import financeNav from "./finance";
import googleDiscoverNav from "./googleDiscover";
import rmrnAnalyticsNav from "./rmrAnalytics";
import LinkMessagingApps from "./linkMessagingApps";
import webPerf from "./webPerf";
import gTrends from "./gTrends";
import rmrAi from "./rmrAi";
import marketingNav from "./marketing";
import geoNav from "./geo";
import autoEmailReportNav from "./autoEmailReport";


export default [
  ...generalNav,
  ...rmrAi,
  ...audienceNav,
  ...socialNav,
  ...programmatiqueNav,
  ...regieNav,
  ...marmitonNav,
  ...googleDiscoverNav,
  ...LinkMessagingApps,
  ...gTrends,
  ...arbitrageNav,
  ...webPerf,
  ...ctcNav,
  ...crmNav,
  ...financeNav,
  ...rmrnAnalyticsNav,
  ...partners,
  ...marketingNav,
  ...geoNav,
  ...adminNav,
];


